// Ирцийн өдрийн жагсаалт — огноо · гараг · төлөв · ирсэн цаг.
// Эцэг эхийн болон сурагчийн нүүр хоёулаа ашиглана.
import React, { useState } from "react";
import dayjs from "dayjs";

export const ST = {
  Ирсэн: { chip: "bg-emerald-50 text-emerald-700 border-emerald-200", soft: "bg-emerald-50 text-emerald-800" },
  Хоцорсон: { chip: "bg-amber-50 text-amber-700 border-amber-200", soft: "bg-amber-50 text-amber-800" },
  Тасалсан: { chip: "bg-red-50 text-red-600 border-red-200", soft: "bg-red-50 text-red-700" },
  Чөлөөтэй: { chip: "bg-blue-50 text-blue-700 border-blue-200", soft: "bg-blue-50 text-blue-800" },
  Өвчтэй: { chip: "bg-purple-50 text-purple-700 border-purple-200", soft: "bg-purple-50 text-purple-800" },
};
export const ORDER = ["Ирсэн", "Хоцорсон", "Тасалсан", "Чөлөөтэй", "Өвчтэй"];
// Ирсэн цаг зөвхөн ирсэн/хоцорсон үед утгатай
export const HAS_TIME = ["Ирсэн", "Хоцорсон"];
export const DOW_FULL = ["Ням", "Даваа", "Мягмар", "Лхагва", "Пүрэв", "Баасан", "Бямба"];

// days: [{ date, status, time }] — шинэ нь дээрээ эрэмбэлнэ
export default function AttendanceDays({ days = [], today, limit = 7 }) {
  const [all, setAll] = useState(false);
  const sorted = [...days].sort((a, b) => String(b.date).localeCompare(String(a.date)));
  const shown = all ? sorted : sorted.slice(0, limit);

  if (!sorted.length)
    return <div className="text-sm text-gray-400 py-4 text-center">Энэ хугацаанд ирц бүртгэгдээгүй</div>;

  return (
    <div>
      <div className="flex flex-col divide-y divide-gray-50">
        {shown.map((d) => {
          const day = dayjs(d.date);
          const isToday = day.format("YYYY-MM-DD") === (today || dayjs().format("YYYY-MM-DD"));
          const st = ST[d.status] || {};
          return (
            <div key={d.date} className={`flex items-center gap-3 py-2.5 ${isToday ? "bg-primary/5 -mx-2 px-2 rounded-lg" : ""}`}>
              <div className="w-11 text-center shrink-0">
                <div className="text-base font-bold leading-none text-gray-800">{day.format("DD")}</div>
                <div className="text-[10px] text-gray-400 mt-0.5">{DOW_FULL[day.day()].slice(0, 2)}</div>
              </div>
              <span className={`text-xs font-semibold px-2.5 py-1 rounded-full border ${st.chip || "bg-gray-50 text-gray-500 border-gray-200"}`}>
                {d.status}
              </span>
              <span className="flex-1" />
              <span className="text-sm font-bold text-gray-700 tabular-nums">
                {d.time && HAS_TIME.includes(d.status) ? dayjs(d.time).format("HH:mm") : <span className="text-gray-300">—</span>}
              </span>
            </div>
          );
        })}
      </div>
      {sorted.length > limit && (
        <button onClick={() => setAll((v) => !v)} className="w-full mt-2 py-2 text-xs font-medium text-primary">
          {all ? "Хураах ▲" : `Бүгдийг харах (${sorted.length}) ▼`}
        </button>
      )}
    </div>
  );
}

// Төлөв бүрийн тоо — чип эгнээ
export function StatusChips({ counts }) {
  return (
    <div className="flex gap-1.5 flex-wrap">
      {ORDER.filter((k) => counts?.[k]).map((k) => (
        <span key={k} className={`text-[11px] font-medium px-2 py-1 rounded-full border ${ST[k].chip}`}>
          {k} {counts[k]}
        </span>
      ))}
    </div>
  );
}
